import { ReportingEventNumberDto } from '@mark43/cad-api';
import { useMemo } from 'react';
import { useCurrentUser } from '../../current-user/current-user';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';

export function useDisplayedReportingEventNumbers({
    reportingEventNumbers,
}: {
    reportingEventNumbers: ReportingEventNumberDto[] | undefined;
}) {
    const unitAssignment = useUnitAssignment();
    const currentUser = useCurrentUser();
    const agencyId = unitAssignment?.unitAgencyId || currentUser?.departmentAgencyId;

    return useMemo(() => {
        if (reportingEventNumbers === undefined) {
            return [];
        }

        return reportingEventNumbers.filter((ren) => ren.agencyId === agencyId);
    }, [reportingEventNumbers, agencyId]);
}
